var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{directives:[{name:"lazyload",rawName:"v-lazyload"}],staticClass:"image__wrapper overflow-hidden mb-0"},[_c('Spinner',{staticClass:"image__spinner"}),_c('img',{staticClass:"image__item object-cover object-top",attrs:{"data-avatar":_vm.avatar,"data-url":_vm.source,"alt":_vm.alt || 'Image'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }